module.exports = __webpack_public_path__ + "img/int-login.8b15af6d.svg";